module.exports = __webpack_public_path__ + "static/media/arrow_copie_2.4821847d.svg";